export default function PlusIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <g clipPath="url(#clip0_2298_19214)">
        <path
          d="M24.5 12C24.5 15.1826 23.2357 18.2348 20.9853 20.4853C18.7348 22.7357 15.6826 24 12.5 24C9.3174 24 6.26516 22.7357 4.01472 20.4853C1.76428 18.2348 0.5 15.1826 0.5 12C0.5 8.8174 1.76428 5.76516 4.01472 3.51472C6.26516 1.26428 9.3174 0 12.5 0C15.6826 0 18.7348 1.26428 20.9853 3.51472C23.2357 5.76516 24.5 8.8174 24.5 12ZM13.25 6.75C13.25 6.55109 13.171 6.36032 13.0303 6.21967C12.8897 6.07902 12.6989 6 12.5 6C12.3011 6 12.1103 6.07902 11.9697 6.21967C11.829 6.36032 11.75 6.55109 11.75 6.75V11.25H7.25C7.05109 11.25 6.86032 11.329 6.71967 11.4697C6.57902 11.6103 6.5 11.8011 6.5 12C6.5 12.1989 6.57902 12.3897 6.71967 12.5303C6.86032 12.671 7.05109 12.75 7.25 12.75H11.75V17.25C11.75 17.4489 11.829 17.6397 11.9697 17.7803C12.1103 17.921 12.3011 18 12.5 18C12.6989 18 12.8897 17.921 13.0303 17.7803C13.171 17.6397 13.25 17.4489 13.25 17.25V12.75H17.75C17.9489 12.75 18.1397 12.671 18.2803 12.5303C18.421 12.3897 18.5 12.1989 18.5 12C18.5 11.8011 18.421 11.6103 18.2803 11.4697C18.1397 11.329 17.9489 11.25 17.75 11.25H13.25V6.75Z"
          fill="#4A72FF"
        />
      </g>
      <defs>
        <clipPath id="clip0_2298_19214">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
